import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";

const FooterSection = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row gy-4">
          {/* Logo & Description */}
          <div className="col-lg-3 col-md-6">
            <Link to="/" className="footer-logo-box">
              <img
                src="/Images/tour/logo.jpeg"
                alt="muktinath logo"
                className="footer-logo"
              />
            </Link>
            <p className="footer-desc">
              Discover the best of India with <b>Budget Golden Triangle Tours</b>.
              We offer budget and customized Golden Triangle tour packages covering
              Delhi, Agra, and Jaipur with expert planning, private transport,
              guided sightseeing, and memorable cultural experiences.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-lg-3 col-md-6">
            <h5 className="footer-heading">Quick Links</h5>
            <div className="footer-line" />
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about-us">About </Link></li>
              {/* <li><Link to="/tour-packages">Tour Packages</Link></li> */}
              {/* <li><Link to="/activities">Activities</Link></li> */}
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
            </ul>
          </div>  

          {/* Popular Destinations */}
          <div className="col-lg-3 col-md-6">
            <h5 className="footer-heading">Popular Destinations</h5>
            <div className="footer-line" />
            <ul className="footer-links two-column">
              <li><Link to="/">Kathmandu</Link></li>
              <li><Link to="/">Pokhara</Link></li>
              {/* <li><Link to="/port-blair">Port Blair</Link></li> */}
              <li><Link to="/">Manokamna</Link></li>
              <li><Link to="/">Lumbini</Link></li>
              <li><Link to="/">Muktinath</Link></li>
              {/* <li><Link to="/radhanagar-beach">Radhanagar Beach</Link></li> */}
              {/* <li><Link to="/elephant-beach">Elephant Beach</Link></li> */}
              <li><Link to="/">Chitwan</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-lg-3 col-md-6">
            <h5 className="footer-heading">Contact Us</h5>
            <div className="footer-line" />

            <div className="footer-contact">
              <div className="contact-footer-item">
                <div className="contact-icon">
                  <FaMapMarkerAlt />
                </div>
                <div>
                  <p>Office Location</p>
                  <a
                    href="https://maps.app.goo.gl/hBdNok4XSiJjBRMQ8"
                    target="_blank"
                    rel="noreferrer"
                  >
                    City Linkers Tours & Travels <br />
                    Flat No: 34D, Block H, Saket,<br />
                    New Delhi - 110017 
                  </a>
                </div>
              </div>

              <div className="contact-footer-item">
                <div className="contact-icon">
                  <FaPhoneAlt />
                </div>
                <div>
                  <p>Phone</p>
                  <a href="tel:+91-9911363366">+91-9911363366</a>
                </div>
              </div>

              <div className="contact-footer-item">
                <div className="contact-icon">
                  <FaEnvelope />
                </div>
                <div>
                  <p>Email</p>
                  <a href="mailto:budgetgoldentriangletours@gmail.com">
                    budgetgoldentriangletours@gmail.com
                  </a>
                </div>
              </div>

              <div className="footer-socials">
                <a href="#"><FaFacebookF /></a>
                <a href="#"><FaTwitter /></a>
                <a href="#"><FaInstagram /></a>
                <a href="#"><FaYoutube /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
